import { TIME_REPORT_EDITABLE_STAGES } from "../constants";
import { TimeReport } from "../types";

export const isTimeReportEditable = (timeReport: TimeReport) =>
  TIME_REPORT_EDITABLE_STAGES.includes(timeReport.stage.code);
